<template>
  <div
    class="openended-wrap"
    :class="{'open-ended-presenting-mode': $store.getters.isPresenting,
             'white': $store.state.slideActive.textColour == '#ffffff'}"
  >
    <div
      class="openended-grid vertical layout"
      v-if="$store.state.slideActive.layout == 'grid' && checkShowContent()"
    >
      <transition name="fade">
        <div
          v-if="arrowScrollTopVisible"
          class="horizontal layout center center-justified fix-height"
          :class="{'is-exporting-pdf': isScreenCapture}"
        >
          <div @click="scrollTop" class="arrow-grid no-absolute">
            <i class="fas fa-chevron-up" />
          </div>
        </div>
      </transition>

      <!-- MASONRY layout -->
      <OpenEndedMasonry
        class="masonry-openended"
        :is-loaded="dataPageSelected.loaded"
        :options="dataPageSelected.options"
        :masonryTransitionDuration="masonryTransitionDuration"
        @pickOption="pickOption"
        @removeResponse="_removeResponse"
      />

      <!-- PAGINATION -->
      <div class="horizontal layout center end-justified fix-height">
        <div
          class="horizontal layout center pagination-openended"
          v-show="$store.state.slideActive.openededCount > limitRowOfPage"
        >
          <i
            class="fas fa-caret-left"
            @click="backPageOpeneded()"
            :class="{'not-show': page === 1}"
          />
          <span
            v-html="$t('pagination', {
              msg: `<strong id='open-ended--page-${page}'>${page}</strong>`,
              num: getTotalPageHtml()
            })"
          />
          <i
            class="fas fa-caret-right"
            id="open-ended--next-page"
            @click="nextPageOpeneded()"
            :class="{'not-show': page === totalPage || hideIconNextPage}"
          />
        </div>
        <transition name="fade">
          <div
            class="arrow-grid"
            @click="scrollBottom"
            v-if="arrowScrollBottomVisible"
            :class="{ 'disabled': scrollDisable,
                      'is-exporting-pdf': isScreenCapture
            }"
          >
            <i class="fas fa-chevron-down" />
          </div>
        </transition>
      </div>
    </div>

    <OpenEndedRemovePickedOption
      :itemPicked="itemPicked"
      v-show="!show"
      @removePickOption="removePickOption"
    />

    <!-- ONE BY ONE layout -->
    <OpenEndedOneByOneContent
      v-if="slideActive.layout == 'oneByOne' && checkShowContent()"
      :animationName="animationName"
      :show="show"
      :optionActive="optionActive"
      @nextOption="nextOption"
      @backOption="backOption"
      @removeResponse="_removeResponse"
      :optionActiveDeleting="optionActiveDeleting"
    />
    <CanvasQuestionImage
      v-show="slideActive.showQuestionImage && slideActive.image"
      @imageLoaded="isLoading = false"
      :isLoading="isLoading"
    />
  </div>
</template>
<script>
import _ from 'lodash'
import { mapState, mapActions, mapGetters } from 'vuex'
import Constant from '@/constant'
import EventBus from '@/eventBus'
import Util from '@/util'
import PresentationUtils from '@/utils/presentation'
import Config from '@/config'
import Socket from '@/socket'
import slideOptionApi from '@/api/slideOption'

// UI
import OpenEndedMasonry from '@/components-v2/presentation-editor/middle/OpenEndedMasonry.vue'
import OpenEndedRemovePickedOption from '@/components-v2/presentation-editor/middle/OpenEndedRemovePickedOption.vue'
import OpenEndedOneByOneContent from '@/components-v2/presentation-editor/middle/OpenEndedOneByOneContent.vue'
import CanvasQuestionImage from '@/components-v2/presentation-editor/middle/CanvasQuestionImage.vue'

export default {
  components: {
    OpenEndedMasonry,
    OpenEndedRemovePickedOption,
    OpenEndedOneByOneContent,
    CanvasQuestionImage,
  },
  data() {
    return {
      optionActive: {
        indexOption: 0,
      },
      show: true,
      itemPicked: {},
      animationName: '',
      scrollShow: false,
      scrollDisable: false,
      currentSlideId: '',
      isLoading: false,
      data: [],
      totalPage: 1,
      page: 1,
      dataPageSelected: {
        page: 1,
        options: [],
      },
      openededCount: 0,
      showArrowScrollTop: false,
      showArrowScrollBottom: true,
      hideIconNextPage: false,
      limitRowOfPage: 30,
      optionActiveDeleting: false,
      masonryTransitionDuration: Constant.MASONRY_TRANSITION_DURATION,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      isScreenCapture: (state) => state.isScreenCapture,
      sharePresentation: (state) => state.sharePresentation,
    }),
    ...mapGetters(['isBackstage']),
    arrowScrollTopVisible() {
      return this.scrollShow && this.showArrowScrollTop
    },
    arrowScrollBottomVisible() {
      return this.scrollShow && this.showArrowScrollBottom
    },
    isImageSubmissionVisible() {
      return this.slideActive.imageSubmission &&
        this.slideActive.type === 'openEnded'
    },
  },
  watch: {
    '$store.state.slideActive': function watchSlideActive() {
      setTimeout(() => {
        if (this.$refs['slide-imgg'] && !this.$refs['slide-imgg'].complete) {
          this.isLoading = true
        }
      }, 1)
      if (
        this.currentSlideId != this.$store.state.slideActive.id ||
        (this.$store.state.slideActive.image &&
          this.$store.state.slideActive.showQuestionImage)
      ) {
        this.currentSlideId = this.$store.state.slideActive.id
        this.itemPicked = {}
        this.show = true
      }
    },

    '$store.state.slideActive.layout': function watchLayout() {
      if (this.$store.state.slideActive.layout === 'grid') {
        setTimeout(() => {
          const container = this.$el.querySelector('#masonry-container')
          if (container && container.scrollHeight > container.clientHeight) {
            this.scrollShow = true
          } else {
            this.scrollShow = false
          }

          if (container && !container.onscroll) {
            container.onscroll = () => {
              this._handleScroll(container)
            }
          }
        }, 1000)
      }
    },
  },
  mounted() {
    this.currentSlideId = this.$store.state.slideActive.id
    if (this.$store.state.sharePresentation) {
      this.updateSlideActiveAction({
        showQuestionImage: false,
      })
    }

    this.page = 1
    this.data = []
    this.openededCount = 0

    if (!this.isScreenCapture) {
      this._loadMoreData(this.page, (data) => {
        this.totalPage = parseInt(data.count / this.limitRowOfPage, 10) + 1
        for (let i = 1; i <= this.totalPage; i++) {
          this.data.push({
            index: i,
            options: [],
          })
        }
        this.data[0].loaded = true
        this.data[0].options = data.rows
        this.updateSlideActiveAction({
          openededCount: data.count,
        })

        this.openededCount = data.count
        this.selectPage(0)
        this._preLoadDataOpeneded()

        this.$store.dispatch('updateSlideActive', this.$store.state.slideActive)

        const self = this
        EventBus.$on('onKeyboard', (e) => {
          if (self.$store.state.slideActive.type === 'openEnded') {
            self.handleSlideControlsKeydown(e)
          }
        })

        EventBus.$on('new-open-ended-response', (doc) => {
          self.openededCount++
          self._handleCountOpendedThrottled()
          self._handleNewOpended(doc)
        })

        EventBus.$on('handleRemovePickOption', () => {
          this.removePickOption()
        })

        const indexOptionOneByOneActive = 0
        this._getOptionOneByOneActive(indexOptionOneByOneActive)
        if (this.slideActive.hasPickedSubmission) {
          this.updateSlideActiveAction({
            hasPickedSubmission: false,
          })
        }

        setTimeout(() => {
          if (this.$store.state.slideActive.layout === 'grid' && !this.isScreenCapture) {
            this._registerScroll()
          }
        }, 500)
      })
    } else {
      this.importFontsForCapture()
      // If capturing active Open-Ended slide, switch layout mode to 'grid'
      this.updateSlideActiveAction({
        layout: 'grid',
      })
      this.masonryTransitionDuration = 0
      this._limitRowOfPageWhenScreenCapture()
      Util.disallowPDFRender()
      this._loadMoreData(this.page, (data) => {
        this.totalPage = parseInt(data.count / this.limitRowOfPage, 10) + 1
        for (let i = 1; i <= this.totalPage; i++) {
          this.data.push({
            index: i,
            options: [],
          })
        }
        this.data[0].loaded = true
        this.data[0].options = data.rows
        this.updateSlideActiveAction({
          openededCount: data.count,
        })

        this.openededCount = data.count
        this.selectPage(0)

        this._setPrintViewport()
        setTimeout(() => {
          Util.allowPDFRender()
        }, 4000)
      })
    }

    window.getScreenshotHeight = function (elem) {
      return elem.scrollHeight
    }
  },

  destroyed() {
    EventBus.$off('new-open-ended-response')
    EventBus.$off('handleRemovePickOption')
    this._resetPrintViewport()
    Util.allowPDFRender()
  },

  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncLoadingAction']),
    _limitRowOfPageWhenScreenCapture() {
      this.limitRowOfPage = 60
    },
    _registerScroll() {
      const container = this.$el.querySelector('#masonry-container')
      if (container && container.scrollHeight > container.clientHeight) {
        this.scrollShow = true
      }

      if (container && !container.onscroll) {
        container.onscroll = () => {
          this._handleScroll(container)
        }
      }
    },

    // AHA-7209: open-ended slides that has too many responses need to be extended
    _setPrintViewport() {
      if (!this.isScreenCapture) return
      if (this.openededCount < 6) {
        this._resetPrintViewport()
        return
      }
      const container = document.querySelector('.masonry-content')
      const mainSlide = document.getElementById('main-slide')
      const containerSlide = document.getElementById('slide-container')
      const middleContainer = document.querySelector('.middle-presentation.capture-mode')
      const wrapSlideIntro = document.querySelector('.wrap-slide-intro')

      if (mainSlide && containerSlide && container && middleContainer && wrapSlideIntro) {
        setTimeout(() => {
          const height = container.scrollHeight > 720 ? container.scrollHeight : 720
          mainSlide.style.height = `${height + 300}px`
          containerSlide.style.height = `${height + 300}px`
          middleContainer.style.height = `${height}px`
          wrapSlideIntro.style.height = `${height + 100}px`
        }, 600)
      }
    },
    _resetPrintViewport() {
      if (this.isScreenCapture) {
        EventBus.$emit('detectScreen', true)
        const wrapSlideIntro = document.querySelector('.wrap-slide-intro')
        if (wrapSlideIntro) {
          wrapSlideIntro.style.height = '100%'
        }
      }
    },
    _handleScroll(container) {
      this._setPrintViewport()
      if (container.scrollHeight <= container.clientHeight) {
        this.showArrowScrollTop = false
        this.showArrowScrollBottom = false
        return
      }

      if (container.scrollTop === 0) {
        this.showArrowScrollTop = false
        this.showArrowScrollBottom = true
        return
      }

      if (container.scrollHeight <= Math.ceil(container.scrollTop + container.clientHeight)) {
        this.showArrowScrollTop = true
        this.showArrowScrollBottom = false
        return
      }

      this.showArrowScrollTop = true
      this.showArrowScrollBottom = true
    },

    countTotalPage() {
      const maxRow = (this.totalPage - 1) * this.limitRowOfPage
      if (this.openededCount === maxRow) {
        if (this.page === this.totalPage - 1) {
          this.hideIconNextPage = true
        } else {
          this.hideIconNextPage = false
        }
        return this.totalPage - 1
      }
      this.hideIconNextPage = false
      return this.totalPage
    },
    setBoxShadowValue(item, index) {
      return `0 0 0 1.5px ${Util.setToColorPalette(item, index)}`
    },
    getTotalPageHtml() {
      // DISCLAMER: Don't remove this 'open-ended--total-page' id, because the PDF export worker
      // need this to know how many open-ended pages are there to render correctly.
      return `<strong id="open-ended--total-page">${this.countTotalPage()}</strong>`
    },
    _preloadImages(allSlideOptions) {
      const images = []
      allSlideOptions.forEach((option) => {
        if (option.image) {
          images.push({
            type: 'openEnded',
            url: option.image,
          })
        }
      })
      images.forEach((image) => {
        Util.preloadImage(image)
      })
    },
    _getOptionOneByOneActive(index) {
      this.optionActiveDeleting = false
      if (!index) index = 0
      if (!this.data.length) return
      if (!this.data[0].options.length) return
      let arr = []
      this.data.forEach((item) => {
        arr = arr.concat(item.options)
      })
      if (!arr.length) return
      if (index >= arr.length) index = arr.length - 1
      this.optionActive = arr[index]
      this.optionActive.indexOption = index
    },
    _handleCountOpendedThrottled: _.throttle(function countOpenEndedThrottled() {
      this.updateSlideActiveAction({
        openededCount: this.openededCount,
      })

      this._registerScroll()
    }, 300),
    _handleNewOpended(doc) {
      if (this.page === this.totalPage) {
        if (this.data[this.page - 1].options.length < this.limitRowOfPage) {
          this.data[this.page - 1].options.push(doc)
        }
      } else if (this.page < this.totalPage) {
        // handle case when a new open ended is added
        // AND user is on the previous page
        this.data[this.totalPage - 1].loaded = false
        this._preLoadDataOpeneded()
      }

      const totalPage =
        parseInt(this.openededCount / this.limitRowOfPage, 10) + 1
      if (totalPage > this.totalPage) {
        this.data.push({
          index: this.data.length + 1,
          options: [],
          loaded: false,
        })
        this.totalPage = totalPage
      }

      if (!this.optionActive.id) {
        this._getOptionOneByOneActive(0)
      }
    },
    _preLoadDataOpeneded() {
      if (this.page === this.totalPage) return
      const page = this.page + 1
      if (this.data[page - 1].loaded) return
      this._loadMoreData(page, (data) => {
        this.data[page - 1].options = data.rows
        this.data[page - 1].loaded = true
        this.data.push()

        if (this.dataPageSelected.index === page) {
          this.selectPage(page - 1)
        }
      })
    },
    selectPage(index) {
      if (index < 0) index = 0
      this.dataPageSelected = this.data[index]
    },
    backPageOpeneded() {
      if (this.page === 1) return
      this.page--
      this.selectPage(this.page - 1)
      const container = this.$el.querySelector('#masonry-container')
      container.scrollTop = 0
      this.showArrowScrollTop = false
      this._handleScroll(container)

      Util.mixpanelTracking(
        'Open Ended',
        'Open Ended > Previous Page',
        'Presenter Previous page',
      )
    },

    nextPageOpeneded() {
      if (this.page === this.totalPage) return
      this.page++
      const page = this.page - 1
      if (!this.isScreenCapture) {
        this.selectPage(page)
        this._preLoadDataOpeneded()
        const container = this.$el.querySelector('#masonry-container')
        if (container) {
          if (!this.dataPageSelected.loaded) {
            this._loadMoreData(page + 1, (data) => {
              if (page + 1 === this.dataPageSelected.index) {
                this.data[page].loaded = true
                this.data[page].options = data.rows
                this.selectPage(page)
                container.scrollTop = 0
                this.showArrowScrollTop = false
                this._handleScroll(container)
              }
            })
          }
          container.scrollTop = 0
          this.showArrowScrollTop = false
          this._handleScroll(container)
          Util.mixpanelTracking(
            'Open Ended',
            'Open Ended > Next Page',
            'Presenter Next page',
          )
        }
      } else {
        this._loadMoreData(page + 1, (data) => {
          this.data[page].loaded = true
          this.data[page].options = data.rows
          this.selectPage(page)
          this._setPrintViewport()
          setTimeout(() => {
            Util.allowPDFRender()
          }, 4000)
        })
      }
    },

    async _loadMoreData(page, cb) {
      try {
        Util.disallowPDFRender()
        const res = await slideOptionApi.getDataOpenended(
          page, this.limitRowOfPage, this.$store.state.slideActive.id,
        )
        if (this.slideActive.imageSubmission) {
          this._preloadImages(res.body.rows)
        }
        if (!this.sharePresentation && !this.isScreenCapture) {
          const totalPage = parseInt(res.body.count / this.limitRowOfPage, 10) + 1
          EventBus.$emit('open-ended: has-pagination', totalPage > 1)
        }
        cb(res.body)
      } catch (error) {
        if (!error.status) return
        this.setSyncLoadingAction(3)
        throw error
      }
    },
    handleSlideControlsKeydown(e) {
      if (
        this.$store.getters.isPresenting &&
        this.$store.state.slideActive.layout === 'grid'
      ) {
        if (e.code === 'ArrowDown') {
          this.scrollBottom()
        } else if (e.code === 'ArrowUp') {
          this.scrollTop()
        }
        return
      }
      if (
        this.$store.getters.isPresenting &&
        this.$store.state.slideActive.layout === 'oneByOne'
      ) {
        if (
          e.code === 'ArrowUp' &&
          this.$store.state.slideActive.openededCount &&
          this.optionActive.indexOption
        ) {
          this.backOption()
        } else if (
          e.code === 'ArrowDown' &&
          this.$store.state.slideActive.openededCount &&
          this.optionActive.indexOption !=
            this.$store.state.slideActive.openededCount - 1
        ) {
          this.nextOption()
        }
      }
    },

    setToColorPalette(item, index) {
      return Util.setToColorPalette(item, index)
    },

    backOption() {
      if (this.$store.state.slideActive.layout === 'oneByOne' && this.itemPicked.id) {
        this.itemPicked = {}
      }
      this.animationName = 'slide-down'
      setTimeout(() => {
        this.show = false
        setTimeout(() => {
          this.show = true
        }, 500)
        if (!this.optionActive) return
        let index = this.optionActive.indexOption - 1
        if (index < 0) {
          index = 0
        }
        this._getOptionOneByOneActive(index)
        Util.mixpanelTracking(
          'Slide type',
          'Open Ended Back Question',
          'Presenter use arrowup',
        )
      }, 200)
    },

    nextOption(text) {
      if (this.$store.state.slideActive.layout === 'oneByOne' && this.itemPicked.id) {
        this.itemPicked = {}
      }
      this.animationName = 'slide-up'
      let index
      setTimeout(() => {
        this.show = false

        setTimeout(() => {
          this.show = true
        }, 500)
        if (!this.optionActive) return
        if (text === 'remove') {
          index = this.optionActive.indexOption
        } else {
          index = this.optionActive.indexOption + 1
        }

        this._getOptionOneByOneActive(index)

        const indexPage = parseInt(index / this.limitRowOfPage, 10) + 1
        if (indexPage !== this.page) {
          this.nextPageOpeneded()
        }

        Util.mixpanelTracking(
          'Slide type',
          'Open Ended Next Question',
          'Presenter use arrowdown',
        )
      }, 200)
    },

    pickOption(item, index) {
      this.show = false
      this.updateSlideActiveAction({
        hasPickedSubmission: true,
      })
      this.itemPicked = item
      this.itemPicked.indexOption = index
      Util.mixpanelTracking(
        Constant.eventCategories.PRESENTATION_EDITOR,
        'Open ended > Pick a question > Show question',
        item,
      )
    },

    removePickOption() {
      this.itemPicked = {}
      Util.mixpanelTracking(
        Constant.eventCategories.PRESENTATION_EDITOR,
        'Open ended > Unpick a question > Hide question',
      )
      this.updateSlideActiveAction({
        hasPickedSubmission: false,
      })
      setTimeout(() => {
        this.show = true
      }, 200)
    },

    scrollBottom() {
      const container = this.$el.querySelector('#masonry-container')
      if (!container) return

      Util.scrollToElement(container, {
        behavior: 'smooth',
        top: container.scrollTop + 70,
      })

      if (
        container.scrollTop + container.clientHeight ==
        container.scrollHeight
      ) {
        this.scrollDisable = true
      }
    },

    scrollTop() {
      const container = this.$el.querySelector('#masonry-container')
      if (!container) return

      this.scrollDisable = false

      Util.scrollToElement(container, {
        behavior: 'smooth',
        top: container.scrollTop < 0 ? 0 : container.scrollTop - 70,
      })
    },
    checkShowContent() {
      let show = true

      if (
        this.$store.state.slideActive.showQuestionImage &&
        this.$store.state.slideActive.image
      ) {
        show = false
      } else if (!this.$store.state.slideActive.hideResult) {
        show = true
      } else if (Util.getParamValue('capture')) {
        show = true
      } else {
        show = false
      }
      return show
    },
    _removeResponse(item) {
      item.deleting = true
      this.dataPageSelected.options.push()
      if (this.optionActive) {
        this.optionActiveDeleting = true
      }
      this.$http
        .put(Config.api.updateSlideOption + item.id, {
          deleted: true,
          presentationId: this.$store.state.presentation.id,
          accessCode: this.$store.state.presentation.uniqueAccessCode,
          socketId: Socket.getSocketId(),
          presenting: this.$store.getters.isPresenting,
        })
        .then(() => {
          if (this.page === 1 && this.data[0].options.length === 1) {
            this.data[0].options = []
            this.selectPage(0)
            this.optionActive = {
              indexOption: 0,
            }
            this.updateSlideActiveAction({
              openededCount: 0,
            })
            this.openededCount = 0
            PresentationUtils.checkAndUpdatePresentationHasResults()
            this.optionActiveDeleting = false
            return
          }

          if (this.page < this.totalPage) {
            for (let i = this.page; i < this.totalPage; i++) {
              this.data[i].loaded = false
              this.data[i].options = []
            }
          }
          this._loadMoreData(this.page, (data) => {
            const totalPage = parseInt(data.count / this.limitRowOfPage, 10) + 1
            if (totalPage < this.totalPage) {
              this.data.splice(this.data.length - 1, 1)
            }
            this.totalPage = totalPage
            this.data[this.page - 1].options = data.rows
            this.selectPage(this.page - 1)
            this._preLoadDataOpeneded()
            this.updateSlideActiveAction({
              openededCount: data.count,
            })

            this.openededCount = data.count
            if (!this.data[this.data.length - 1].options.length && this.page === this.totalPage) {
              this.selectPage(this.page - 2)
              this.page--
              this.data[this.data.length - 1].loaded = false
            }

            if (this.slideActive.layout === 'oneByOne') {
              if (!this.slideActive.openededCount) {
                this.optionActive = {}
              } else if (
                this.optionActive.indexOption >= this.slideActive.openededCount - 1
              ) {
                this.backOption()
              } else if (
                this.optionActive.indexOption < this.slideActive.openededCount - 1
              ) {
                this.optionActive.indexOption--
                this.nextOption()
              }
            }
          })
          if (this.slideActive.layout === 'grid') {
            this._getOptionOneByOneActive(0)
          }
        })
      Util.mixpanelTracking(
        'Presentation Editing',
        'Edit open ended question',
        'Delete option',
      )
    },

    _openEndedBg(text) {
      if (this.$store.state.slideActive.layout == 'oneByOne') {
        if (this.$store.state.slideActive.textColour == '#313131') {
          return 'rgba(255, 255, 255, 0.75)'
        }
        return 'rgba(255, 255, 255, 0.08)'
      }
      if (text) {
        return this.$store.state.slideActive.baseColour
      }
      const color = Util.hexToRgba(this.$store.state.slideActive.baseColour)
      return Util.changeRgbaColor(color, 0.6)
    },

    _checkShowAudienceFields(fieldName, audienceInfo) {
      return Util.checkShowAudienceFields(fieldName, audienceInfo)
    },

    _checkShowAudienceInfo(answer) {
      return Util.checkShowAudienceInfo(answer)
    },
    importFontsForCapture() {
      // dynamic imports, no worries about bundle size
      import('@fontsource/merriweather')
      import('@fontsource/roboto')
      import('@fontsource/source-code-pro')
      import('@fontsource/montserrat')
      import('@fontsource/oswald')
      import('@fontsource/eb-garamond')
      import('@fontsource/cairo')
      import('@fontsource/roboto-slab')
      import('@fontsource/kanit')
    },

  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.fix-height {
  min-height: 50px;
}
.full-size {
  width: 100%;
  height: 100%;
}
.arrow-grid.no-absolute {
  position: initial;
  transform: initial;
}

.animate__animated {
  animation-duration: 0.2s;
}
.pagination-openended {
  font-size: 20px;
  i {
    font-size: 26px;
    padding: 10px;
    opacity: 0.6;
    cursor: pointer;

    &.not-show {
      visibility: hidden;
      cursor: auto;
    }
  }
  strong {
    margin: 0 10px;
  }
}
p {
  margin-bottom: 0;
}
.openended-wrap {
  width: 98%;
  margin: 0 auto;
  height: 100%;
  position: relative;
  padding-left: 30px;
  padding-right: 30px;

  & ::v-deep .pre-line {
    cursor: default;
    -webkit-user-select: text;
    -khtml-user-select: text;
    -moz-user-select: text;
    -o-user-select: text;
    user-select: text;
  }
}
.openended-grid {
  position: relative;
  width: 100%;
  height: 100%;
}
.arrow-grid {
  text-align: center;
  font-size: 20px;
  text-align: center;
  font-size: 25px;
  position: absolute;
  cursor: pointer;
  left: 50%;
  transform: translateX(-25%);
  i {
    &.disabled {
      color: #888;
    }

    &:hover {
      color: #666;
    }
  }
  &.is-exporting-pdf {
    opacity: 0;
  }
}

.has-audience-info {
  .info--other-team, .info--other-email {
    font-size: 0.85em;
  }
  &.body-content {
    padding: 0!important;
    .content-title {
      padding: 12px 16px;
      @apply w-full;
    }
    .audience-info {
      padding: 7px 16px;
      line-height: 1.2;
      .info--emoji {
        min-width: 38px;
        font-size: 28px;
      }
    }
  }
  &.open-ended-title {
    padding: 0 !important;
    -webkit-overflow-scrolling: touch; //Chrome
    -ms-overflow-style: none; //IE, edge
    overflow: -moz-scrollbars-none; //Firefox
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
    .title-text {
      padding: 0 30px 25px;
      max-height: 150px;
      min-height: 75px;
      overflow-y: auto;
      margin-top: 25px;
    }
    .audience-info {
      padding: 12px 30px;
      line-height: 1.2;
      .info--emoji {
        min-width: 35px;
        font-size: 30px;
        display: inline-block;
      }
    }
  }
}

.audience-info {
  background-color: rgba(240,241,241,1);
  color: inherit;
  border-radius: 0 0 8px 8px;
  &.dark {
    background-color: rgba(240,241,241,0.1);
  }
}

.masonry-content {
  width: 100%;
  height: 100%;
}

@keyframes popup {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.5);
  }

  100% {
    transform: scale(1);
  }
}

.openended-wrap.white {
  .body-content {
    background-color: rgba(255, 255, 255, 0.1);
  }
  &::v-deep {
    .open-ended-picked, .open-ended-title {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }
}

.title-text .content-image {
  @apply mt-4;
  &::v-deep .enlarge-image__image {
    max-height: 338px;
    max-width: 100%;
  }
}
</style>
